import React from 'react';
import { Row, Col } from 'react-bootstrap';
import UserAllOrderCard from './UserAllOrderCard';

const UserAllOrderItem = ({ item }) => {

    return (
        <div className="mt-5 mx-3 p-3 shadow">
            <Row className='d-flex align-items-center justify-content-between gray-bg p-3 mx-2 mb-4'>
                <Col lg="4" sm="12">
                    <p className="py-2 fw-bold fs-20 mb-0"> Order No {item.id} </p>
                </Col>
                <Col lg="8" sm="12">
                    <Row className="d-flex justify-content-between">
                        <Col md="4" xs="12">
                            {item.isDelivered === false ? (<p className='orange-color  mb-0'>Not Delivered</p>) : (<p className='text-success mb-0'> Delivered</p>)}
                        </Col>
                        <Col md="4" xs="12">
                            {item.paymentMethodType === "cash" ? (<p className='mb-0'>Cach</p>) : (<p className='mb-0'> Visa </p>)}
                        </Col>
                        <Col md="4" xs="12">
                            {item.isPaid === false ? (<p className='orange-color mb-0'>Not Paied</p>) : (<p className='text-success mb-0'> Pied</p>)}
                        </Col >
                    </Row >
                </Col >
            </Row >

            {
                item.cartItems && item.cartItems.length > 0 ? (
                    item.cartItems.map((cartitem, index) => (
                        <UserAllOrderCard key={index} cartitem={cartitem} />
                    ))
                ) : (
                    <h4>No Items</h4>
                )
            }
            <Col xs="12" className="d-flex justify-content-end" >
                <p className='fw-bold orange-color fs-20'>{item.totalOrderPrice} LE</p>
            </Col >
        </div >
    );
};

export default UserAllOrderItem;
